import {
  ConfirmActionDialog,
  SuccessMessage
} from '@eggplant/pattern-library'
import { DeleteExecutionRequest } from '@eggplant/api-requests'
import { useState } from 'react'
import type { CSSProperties } from 'react'

const wrapperStyle: CSSProperties = { width: 500 }

interface Props {
  onCancel: () => void
  onSuccess: () => void
  execution_id: string
}

const AbortRun = ({
  execution_id,
  onCancel,
  onSuccess
}: Props) => {
  const [isAborting, setIsAborting] = useState(false)

  const handleConfirm = () => {
    setIsAborting(true)
  }

  return (
    <div style={wrapperStyle}>
      {
        isAborting
          ? (
            <DeleteExecutionRequest
              id={execution_id}
              onSuccess={onSuccess}
            >
              {
                () =>
                  <SuccessMessage>
                    Abort successfully requested.
                  </SuccessMessage>
              }
            </DeleteExecutionRequest>
          )
          : (
            <ConfirmActionDialog
              actionText='Abort'
              message='This action cannot be undone.'
              onCancel={onCancel}
              onConfirm={handleConfirm}
              title='Abort this test?'
            />
          )
      }
    </div>
  )
}

export default AbortRun
